<template>
  <div class="footer">
    <div class="dutable">
      <el-row>
        <!-- <el-col :span="4"
          ><div class="gslogo">
            <img src="../assets/logo/logo.jpg" alt="" />
            <div>美的夢</div>
          </div></el-col
        > -->
        <el-col :span="3"
          ><div class="grid-content bg-purple-light">
            <div class="dutitle">关于我们</div>
            <div class="ducontant" @click="toAboutUs">品牌文化</div>
          </div></el-col
        >
        <el-col :span="3"
          ><div class="grid-content bg-purple-light">
            <div class="dutitle">产品展示</div>
            <div class="ducontant" @click="toCd">床褥系列</div>
            <div class="ducontant" @click="toCp">床品系列</div>
            <div class="ducontant" @click="toSf">梳化系列</div>
          </div></el-col
        >
        <el-col :span="3"
          ><div class="grid-content bg-purple-light">
            <div class="dutitle">小程序</div>
            <img class="wx" src="../assets/picture/wx.jpg" alt="" /></div
        ></el-col>
        <el-col :span="7"
          ><div class="grid-content bg-purple-light" @click="toContact">
            <div class="dutitle dzt">联系我们（香港）</div>
            <div class="ducontant dz">电话（香港）：(852) 2427-1159</div>
            <div class="ducontant dz">傳真（傳真）：(852) 2480-4601</div>
            <div class="ducontant dz">
              香港葵涌和宜合167-171號金威工業大廈5字樓A座
            </div>
          </div></el-col
        >
        <el-col :span="7"
          ><div class="grid-content bg-purple-light" @click="toContact">
            <div class="dutitle dzt">联系我们（大陸）</div>
            <div class="ducontant dz">电话（大陸）：86 769 8336-2372</div>
            <div class="ducontant dz">傳真（大陸）：86 769 8336-2222</div>
            <div class="ducontant dz">
              中國廣東省東莞市黃江鎮社貝管理區擁軍路
            </div>
          </div></el-col
        >
      </el-row>
    </div>
    <div class="bats">
      粤公网安备 44010502001493号 | Copyright ©
      2010-2020東莞樂滿門床具厂有限公司
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  methods: {
    toAboutUs() {
      this.$router.push({ path: "/about" });
    },
    // 跳转到梳化
    toSf() {
      this.$router.push({ path: "/goods/sf" });
    },
    // 跳转到床墊
    toCd() {
      this.$router.push({ path: "/goods/cd" });
    },
    // 跳转到床品
    toCp() {
      this.$router.push({ path: "/goods/cp" });
    },
    toContact() {
      this.$router.push({ path: "/contact" });
    },
  },
};
</script>

<style scoped>
.footer {
  width: 100%;
  height: 345px;
  background-image: url(http://www.zhonglunnet.com/templets/zlnet/images/footerbg.jpg);
}

.dutable {
  height: 280px;
  width: 1100px;
  margin: 0px auto;
}
.el-col {
  margin-top: 50px;
}

.dutitle {
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
  height: 50px;
  line-height: 50px;
}
.ducontant {
  font-size: 12px;
  color: #b5b5b9;
  height: 24px;
  line-height: 24px;
}

.bats {
  font-size: 13px;
  height: 65px;
  line-height: 60px;
  color: #ffffff;
}

/* 微信二维码 */
.wx {
  width: 90px;
  height: 90px;
}
.dzt {
  text-align: left;
  margin-left: 30px;
}
.dz {
  text-align: left;
  margin-left: 20px;
}
</style>